import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import MenuList from "./MenuList.esm.js";
const dropdownShellClassName = css({
  xl: {
    position: "absolute",
    top: "100%",
    minWidth: "15rem",
    width: "max-content",
    boxShadow: "md",
    backgroundColor: "bg.neutral",
    borderRadius: "{radii.Dropdown.Content}",
    overflow: "hidden",
    zIndex: "dropdown"
  },
  xlDown: {
    width: "100%",
    // Full-width mobile stack: square edges (radius only on desktop flyout `lg` above)
    borderRadius: "{radii.zero}",
    overflow: "hidden"
  }
});
const dropdownMenuListClassName = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
  paddingInlineStart: "0",
  xl: {
    backgroundColor: "transparent"
  },
  xlDown: {
    backgroundColor: "gray.50",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "border.muted",
    paddingBlock: "tighter",
    paddingInline: "0",
    position: "relative"
  }
});
const DropdownMenu = ({
  isOpen,
  children,
  zIndex,
  left = 0
}) => {
  return /* @__PURE__ */ jsx(Box, { className: dropdownShellClassName, hidden: !isOpen, style: {
    display: isOpen ? "block" : "none",
    left,
    ...zIndex ? {
      zIndex
    } : {}
  }, children: /* @__PURE__ */ jsx(MenuList, { className: dropdownMenuListClassName, children }) });
};
export {
  DropdownMenu as default
};
